import { render } from "./slide-referencias.vue?vue&type=template&id=027d775b"
import script from "./slide-referencias.js?vue&type=script&lang=js&external"
export * from "./slide-referencias.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__